import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function CollectionMin(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [minData, setminData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}min-collection-view/?start_date=${startDateString}&end_date=${endDateString}`;
        axios.get(url)
            .then(response => {
                setminData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const rows = minData.filter(item => item.min_paid > 0).map(item => ({
        id: item.id,
        date_time: `${item.add_date_date} ${item.add_time}`,
        appt_id: item.appt_id,
        pat__pat_id: item.pat__pat_id,
        pat__patient: item.pat__patient,
        min_invoice: item.min_invoice,
        min_tot: item.min_tot,
        min_paid: item.min_paid,
        min_balance: item.min_balance,
        min_pmode: item.min_pmode,
        cashier: item.cashier,
    }));
    const columns = [
        {field: 'date_time', headerName: 'Date', width: 160},
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 200},
        {
            field: 'min_invoice', headerName: 'Invoice No',
            renderCell: (params) => (
                <Link to={`/min-invoice-op/${params.row.min_invoice}`} target="_blank">
                    {params.row.min_invoice}
                </Link>
            ),
            width: 120
        },
        {field: 'min_tot', headerName: 'Invoiced Amount', width: 100},
        {field: 'min_paid', headerName: 'Paid Amount', width: 100},
        {field: 'min_balance', headerName: 'Balance', width: 100},
        {field: 'min_pmode', headerName: 'Payment Mode', width: 110},
        {field: 'cashier', headerName: 'Cashier', width: 100},
    ];
    const getTotal = (rows, field) => {
        return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
    };
    const Footer = ({rows}) => {
        const totalInvoicedAmount = getTotal(rows, 'min_tot');
        const totalPaidAmount = getTotal(rows, 'min_paid');
        const totalBalance = getTotal(rows, 'min_balance');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>Invoiced Amount: {totalInvoicedAmount}</div>
                <div>Paid Amount: {totalPaidAmount}</div>
                <div>Balance: {totalBalance}</div>
            </div>
        );
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> Minor Treatment Collection Report</h3>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="user" className="form-label">Select Date</label>
                    <div className="date-filter-container">
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="From Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />

                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="To Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />
                    </div>

                </div>
            </div>

            {!isLoading && minData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}} className="mt-4">
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                              }}
                              autoHeight
                    />
                    <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                        <tfoot>
                        <Footer rows={rows}/>
                        </tfoot>
                    </table>
                </div>
            ) : (
                <></>
            )}
        </section>
    )
}
export default CollectionMin;
